import MD5 from 'crypto-js/md5';

/**
 * MD5 加密
 * 浏览器环境无 Node 的 crypto，使用 crypto-js 实现
 * @param {string} value 待加密的字符串
 * @returns {string} 32 位小写十六进制密文
 */
export function md5(value) {
  return MD5(value === undefined || value === null ? '' : String(value)).toString();
}
